export function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (bytes === 0) {
    return '0 байт';
  }
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['байт', 'КБ', 'МБ', 'ГБ', 'ТБ', 'ПБ', 'ЭБ', 'ЗБ', 'ЙБ'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  var value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  var size = sizes[i];
  return "".concat(value, "\xA0").concat(size);
}